import React from "react";
import L from "leaflet";
import { MapContainer, TileLayer, GeoJSON, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import countyGeoJson from "../data/counties.json";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

const customIcon = new L.Icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export default function Map(props) {
  const [position, setPosition] = React.useState([30.2672, -97.7431]); // Default center position (Austin, TX)

  React.useEffect(() => {
    if (props.latitude && props.longitude) {
      setPosition([props.latitude, props.longitude]);
    }
  }, [props.latitude, props.longitude]);

  return (
    <div>
      <MapContainer
        center={position}
        zoom={5}
        style={{ height: props.height, width: props.width }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
          opacity={0.3}
        />
        <Marker position={position} icon={customIcon}></Marker>
        <GeoJSON data={countyGeoJson} opacity={0.6} />
      </MapContainer>
    </div>
  );
}
